<div class="row">
  <div class="col-md-6">
    <form class="form-horizontal" (submit)="uploadDocument()">
      <div class="card shadow-sm card-body">

        <div class="form-group row">
          <app-material-file-uploader
            [accept]="'.xlsx, .xls'"
            id="noonReportFile"
            name="noonReportFile"
            [(ngModel)]="currentFiles"
            [required]="true"
            tabindex="15">
          </app-material-file-uploader>
        </div>
        <div class="form-group row">
          <app-material-date-range
            id="selectedDateRange"
            [(dateRange)]="selectedDate"
            [singleDateSelector]="true"
            appDateRangeRequired="true">
          </app-material-date-range>
        </div>
        <div class="form-group row">
          <div class="col-md-12">
            <button
              mat-raised-button
              mat-stroked-button
              class="pull-right"
              type="submit"
              id="uploadDocument"
              value="Upload"
              [disabled]="!currentFiles">
              Upload
            </button>
            <button
              mat-raised-button
              mat-stroked-button
              class="pull-right mx-1"
              (click)="cancel()">
              Cancel
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
